import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export default Container;
